import { render, staticRenderFns } from "./thumb-bar.vue?vue&type=template&id=e81c539c&scoped=true&"
import script from "./thumb-bar.vue?vue&type=script&lang=js&"
export * from "./thumb-bar.vue?vue&type=script&lang=js&"
import style0 from "./thumb-bar.vue?vue&type=style&index=0&id=e81c539c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81c539c",
  null
  
)

export default component.exports